export default "__VITE_ASSET__xr5hPvWD__"